export function parseDataUrl(url: string) {
  const content = url.split(',')[1];
  const type = url.split(',')[0].split(':')[1].split(';')[0];
  return { content, type };
}
